@let hasShiftCreatePermission =
  can(RoleAction.Create, RolePermissionSubject.Shift);
@let hasShiftReadPermission = can(RoleAction.Read, RolePermissionSubject.Shift);
<nz-select
  nzAllowClear
  nzShowSearch
  class="w-100"
  [nzDropdownStyle]="nzDropdownStyle"
  [nzDropdownClassName]="'shift-template-dropdown'"
  [nzPlaceHolder]="'general.search' | translate"
  [nzOpen]="isShiftTemplateDropDownOpen"
  (nzOpenChange)="opened.next($event)"
  [ngModel]="selectedShiftTemplate"
  (ngModelChange)="selectTemplate($event)"
  [nzDisabled]="!hasShiftReadPermission"
  nz-tooltip
  [nzTooltipTitle]="
    !hasShiftReadPermission ? ('general.forbidden_action' | translate) : ''
  "
  data-test-id="wilson-shift-template-select"
>
  @if (hasShiftReadPermission) {
    @for (shiftTemplate of shiftTemplates$ | async; track shiftTemplate) {
      <nz-option
        [nzLabel]="shiftTemplate.name"
        [nzValue]="shiftTemplate"
        nzCustomContent
      >
        @if (
          shiftTemplate?.shiftTemplateActivityTemplates || [];
          as shiftTemplateActivityTemplates
        ) {
          <div
            class="shift-template d-flex flex-column align-items-center"
            [style.border-color]="shiftTemplate.colorCode"
            [draggable]="hasShiftCreatePermission"
            (dragstart)="startDrag.emit(shiftTemplate)"
            (dragend)="endDrag.emit()"
          >
            <p class="name mb-1">{{ shiftTemplate.name }}</p>
            <p class="location mb-0">
              {{
                shiftTemplateActivityTemplates[0].activityTemplate.startLocation
                  ?.locationCode
              }}
              -
              {{
                shiftTemplateActivityTemplates[
                  shiftTemplateActivityTemplates.length - 1
                ].activityTemplate.endLocation?.locationCode
              }}
            </p>
          </div>
        }
      </nz-option>
    }
  }
</nz-select>
